import ComingSoon from "@/components/ComingSoon";

export default function MonthlyComplaint() {
  return <ComingSoon />;
}
